import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowsAsc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 18 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.966 4.69 13.548.271l-4.42 4.42 1.18 1.177 2.406-2.406V19.6h1.667V3.461l2.407 2.407zM5.79 13.068V6.75H4.125v6.318l-2.407-2.406L.54 11.84l4.419 4.419 4.418-4.419-1.178-1.178z" })
});
export default SvgArrowsAsc;
